module.exports = __webpack_public_path__ + "img/sleet.1615ef22.svg";